<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import Avatar from "@/components/widgets/avatar";
import AccountTabs from "@/components/AccountTabs";

export default {
  locales: {
    pt: {
      'Username': 'Usuário',
      'Name': 'Nome',
    },
    es: {
      'Username': 'Nombre de Usuario',
      'Name': 'Nombre',
    }
  },
  components: {
    Layout,
    Avatar,
    AccountTabs
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    // CPF parcialmente oculto: ***.***.***-00
    maskedCpf() {
      const digits = String(this.account.user.cpf || '').replace(/\D/g, '');
      if (digits.length < 2) {
        return '-';
      }
      return '***.***.***-' + digits.slice(-2);
    },
    // Data de nascimento em dd/mm/aaaa
    birthday() {
      const value = String(this.account.user.birthday || '');
      const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        return match[3] + '/' + match[2] + '/' + match[1];
      }
      return value || '-';
    }
  },
  data() {
    return {
      shortcuts: [
        { to: '/account/documents', icon: 'bx bx-file', label: 'Documentos' },
        { to: '/account/address', icon: 'bx bx-map', label: 'Endereços' },
        { to: '/account/pix', icon: 'bx bx-transfer', label: 'PIX' },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <AccountTabs></AccountTabs>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <Avatar></Avatar>
          </div>
          <div class="col-md-8 pt-md-5">
            <div class="row pt-3 pb-0 pl-3 pr-3">
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Username') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.username }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Name') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.name }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">CPF</p>
                <p class="mb-3 font-weight-normal notranslate">{{ maskedCpf }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">Data de nascimento</p>
                <p class="mb-3 font-weight-normal notranslate">{{ birthday }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-for="item in shortcuts" :key="item.to" class="col-md-4">
        <router-link :to="item.to" class="card text-dark">
          <div class="card-body d-flex align-items-center justify-content-between">
            <span><i :class="item.icon + ' font-size-20 align-middle mr-2'"></i>{{ item.label }}</span>
            <i class="bx bx-chevron-right font-size-20"></i>
          </div>
        </router-link>
      </div>
    </div>
  </Layout>
</template>
